var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "utxo_container input_container",
    style: {
      backgroundColor: _vm.background
    }
  }, [_c('div', {
    staticClass: "tx_link"
  }, [_c('TxLinkInput', {
    attrs: {
      "tx-i-d": _vm.utxo.output.transactionID,
      "chain-i-d": _vm.utxo.output.chainID,
      "timestamp": _vm.utxo.output.timestamp
    }
  })], 1), _c('div', {
    staticClass: "utxo_new_col"
  }, [_c('Summary', {
    attrs: {
      "index": _vm.$vnode.key,
      "utxo": _vm.utxo.output,
      "is-p-v-m-import": _vm.isPVMImport,
      "is-import": _vm.isImport,
      "is-atomic-import": _vm.isAtomicImport
    }
  }), _c('Addresses', {
    attrs: {
      "addresses": _vm.utxo.output.addresses,
      "type": 'input'
    }
  }), _c('Credentials', {
    attrs: {
      "credentials": _vm.utxo.credentials
    }
  }), _c('LockTime', {
    attrs: {
      "time": _vm.utxo.output.locktime
    }
  }), _c('Threshold', {
    attrs: {
      "threshold": _vm.utxo.output.threshold,
      "addresses": _vm.utxo.output.addresses
    }
  }), _c('Stake', {
    attrs: {
      "is-stake": _vm.utxo.output.stake
    }
  }), _c('Stakeable', {
    attrs: {
      "is-stakeableout": _vm.utxo.output.stakeableout,
      "time": _vm.utxo.output.stakeLocktime
    }
  }), _vm.utxo.output.genesisutxo === true ? _c('div', [_c('div', [_vm._v("UTXO is from genesis")])]) : _vm._e(), _c('NFTPayload', {
    attrs: {
      "payload": _vm.utxo.output.payload,
      "asset-i-d": _vm.utxo.output.assetID,
      "group-i-d": _vm.utxo.output.groupID
    }
  }), _c('Block', {
    attrs: {
      "block": _vm.utxo.output.block,
      "nonce": _vm.utxo.output.nonce
    }
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }